import React from 'react';
import cx from 'classnames';

import glyphs from 'app/constants/glyphs';

import Icon from 'app/components/Icon';

import styles from './styles.css';

const Graph = ({ percentFilled }) => {
  const graphSize = 220;
  const strokeWidth = 45;
  const center = graphSize / 2;
  const radius = graphSize / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const filledValue = circumference * percentFilled;

  const iconClasses = cx({
    [styles.icon]: true,
    [styles.iconWarn]: percentFilled > 0.4 && percentFilled < 0.7,
    [styles.iconStop]: percentFilled > 0.7,
  });

  const circleFilledClasses = cx({
    [styles.circleFilled]: true,
    [styles.circleFilledWarn]: percentFilled > 0.4 && percentFilled < 0.7,
    [styles.circleFilledStop]: percentFilled > 0.7,
  });

  return (
    <div className={styles.container}>
      <Icon icon={glyphs.FLAG} title={'flag'} className={iconClasses} />
      <svg width={graphSize} height={graphSize} className={styles.svg}>
        <circle
          r={radius}
          cx={center}
          cy={center}
          strokeWidth={strokeWidth}
          className={styles.circleBg}
        />
        <circle
          r={radius}
          cx={center}
          cy={center}
          strokeWidth={strokeWidth}
          strokeDasharray={`${filledValue},${circumference}`}
          className={circleFilledClasses}
          style={{ '--circumference': circumference }}
        />
      </svg>
    </div>
  );
};

export default Graph;



// WEBPACK FOOTER //
// ./src/components/ResultsContainer/Graph/index.js